import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Dialog, DialogTrigger } from "@/components/ui/dialog";
import { Toggle } from "@/components/ui/toggle";
import { Users, Plus, List, LayoutGrid } from "lucide-react";
import { WorkforceCardsLayout } from "@/components/rdo/WorkforceCardsLayout";
import { DialogAddWorkforce } from "@/components/rdo/DialogAddWorkforce";

interface LegacyWorkforceSectionProps {
  rdoData: any;
  workforceViewMode: 'cards' | 'table';
  setWorkforceViewMode: (mode: 'cards' | 'table') => void;
  showWorkforceModal: boolean;
  setShowWorkforceModal: (show: boolean) => void;
  handleAddWorkforce: (data: any) => void;
  handleEditWorkforce: (index: number) => void;
  handleDeleteWorkforce: (index: number) => void;
  isEditing: boolean;
  isSectionEnabled: (section: string) => boolean;
}

export function LegacyWorkforceSection({
  rdoData,
  workforceViewMode,
  setWorkforceViewMode,
  showWorkforceModal,
  setShowWorkforceModal,
  handleAddWorkforce,
  handleEditWorkforce,
  handleDeleteWorkforce,
  isEditing,
  isSectionEnabled
}: LegacyWorkforceSectionProps) {
  return (
    <>
      {/* Mão de Obra */}
      {isSectionEnabled('maoDeObra') && (
        <Card data-section="workforce">
          <CardHeader className="pb-3">
            <CardTitle className="text-lg flex items-center gap-2">
              <Users className="w-5 h-5" />
              Mão de Obra ({rdoData.workforce?.reduce((sum: number, w: any) => sum + (w.quantity || 0), 0) || 0})
               {isEditing && !rdoData.approved && (
               <div className="flex gap-2 ml-2">
                 <Toggle
                   pressed={workforceViewMode === 'table'}
                   onPressedChange={(pressed) => setWorkforceViewMode(pressed ? 'table' : 'cards')}
                   variant="outline"
                   size="sm"
                   aria-label="Alternar visualização"
                 >
                   {workforceViewMode === 'cards' ? (
                     <>
                       <List className="w-4 h-4 mr-2" />
                       Lista
                     </>
                   ) : (
                     <>
                       <LayoutGrid className="w-4 h-4 mr-2" />
                       Cards
                     </>
                   )}
                 </Toggle>
                 <Dialog open={showWorkforceModal} onOpenChange={setShowWorkforceModal}>
                   <DialogTrigger asChild>
                     <Button size="sm" variant="outline">
                       <Plus className="w-4 h-4 mr-1" />
                       Individual
                     </Button>
                   </DialogTrigger>
                    <DialogAddWorkforce 
                      open={showWorkforceModal}
                      onOpenChange={setShowWorkforceModal}
                      onAdd={handleAddWorkforce}
                      alreadyAddedTeamNames={rdoData?.workforce?.reduce((teams: string[], item: any) => {
                        // For consolidated teams (have teamName property)
                        if (item.teamName && !teams.includes(item.teamName)) {
                          teams.push(item.teamName);
                        }
                        // For individual items with team assignment
                        if (item.team && item.team !== 'sem-equipe' && !teams.includes(item.team)) {
                          teams.push(item.team);
                        }
                        return teams;
                      }, []) || []}
                    />
                 </Dialog>
               </div>
               )}
            </CardTitle>
          </CardHeader>
          <CardContent>
            {isEditing && !rdoData.approved ? (
              <div className="space-y-4">
                 <WorkforceCardsLayout 
                   workforce={rdoData.workforce || []} 
                   showTotals={true}
                   viewMode={workforceViewMode}
                   onEdit={handleEditWorkforce}
                   onDelete={handleDeleteWorkforce}
                 />
              </div>
            ) : (
               <WorkforceCardsLayout 
                 workforce={rdoData.workforce || []} 
                 showTotals={true}
                 viewMode={workforceViewMode}
                 onEdit={handleEditWorkforce}
                 onDelete={handleDeleteWorkforce}
               />
            )}
          </CardContent>
        </Card>
      )}
    </>
  );
}